export default {
  token: state => {
    return state.authData !== null ? state.authData.access_token : null;
  },
  isAuth: state => {
    return state.authData !== null;
  },
  authData: state => {
    return state.authData;
  },
  userData: state => {
    return state.userData;
  },
  userList: state => {
    return state.userList;
  },
  permissions: state => {
    if (state.userData) {
      return state.userData.permissions;
    }

    return [];
  },
  hasPermission: state => id => {
    if (state.userData && state.userData.permissions) {
      const filtered = state.userData.permissions.filter(item => parseInt(item.id) === parseInt(id));

      return filtered && filtered.length === 1;
    }

    return false;
  },
  lastCookieCheck: state => {
    return state.lastCookieCheck;
  },
  numSnapshotsProcessed: state => {
    return state.numSnapshotsProcessed;
  },
  dumpFiles: state => {
    return state.dumpFiles;
  },
  flags: state => {
    return state.flags;
  },
  restarting: state => {
    return state.restarting;
  },
  email: state => {
    return state.userData.email;
  },
  username: state => {
    return state.userData.username;
  }
};
